// export const baseUrl = "http://localhost:3001/api" // local
export const baseUrl = "https://store-image.onrender.com/api" // prod